module.exports = __webpack_public_path__ + "img/books.afc31cf8.png";